import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BreadcrumbModule } from 'primeng/primeng';
import { TranslateModule } from '@ngx-translate/core';

import { BreadcrumbsComponent } from './breadcrumbs.component';
import { BreadcrumbsService } from './breadcrumbs.service';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    BreadcrumbModule
  ],
  declarations: [
    BreadcrumbsComponent
  ],
  exports: [
    BreadcrumbsComponent
  ],
  providers: [
    BreadcrumbsService
  ]
})
export class BreadcrumbsModule { }



// WEBPACK FOOTER //
// /dist/src/app/ui/breadcrumbs/breadcrumbs.module.ts